<template>
  <div class="welcome">
    <!-- 页头 [[ -->
    <div class="header">
      <div class="header__wrap">
        <div class="header__nav">
          <h1 class="header__logo">
            <i class="header__logo__img" alt="企鹅号小店" title="企鹅号小店" />
          </h1>
          <div class="header__links">
            <div class="header__links__item">
              <a class="link" href="https://docs.qq.com/doc/DTmV6dkh6cUd1WFlD" target="_blank">指引文档</a>
            </div>
            <div class="header__links__item">
              <el-popover
                popper-class="popover-login"
                placement="bottom-end"
                width="140"
                trigger="hover"
                :visible-arrow="false"
              >
                <span slot="reference" class="btn-login">登录</span>
                <div class="btn-list">
                <!--
                  <a class="btn-list__item" :href="omShopLink" target="_blank">
                    <i class="ico ico-shop" />我是供货平台
                  </a>
                  -->
                  <router-link class="btn-list__item" to="/login?user_type=talent">
                    <i class="ico ico-diamonds" />我是达人
                  </router-link>
                </div>
              </el-popover>
            </div>
          </div>
        </div>

        <h1 class="header_intro">
          一站式电商服务覆盖多个腾讯系媒体平台
        </h1>
        <ul class="header__partner">
          <li class="header__partner__item">
            <img width="56" height="56" src="../../assets/logo/circle_80x80/logo_circle_txsp.png" alt="腾讯视频" title="腾讯视频">
          </li>
          <li class="header__partner__item">
            <img width="56" height="56" src="../../assets/logo/circle_80x80/logo_circle_qq.png" alt="腾讯QQ" title="腾讯QQ">
          </li>
          <li class="header__partner__item">
            <img width="56" height="56" src="../../assets/logo/circle_80x80/logo_circle_ws.png" alt="腾讯微视" title="腾讯微视">
          </li>
          <li class="header__partner__item">
            <img width="56" height="56" src="../../assets/logo/circle_80x80/logo_circle_om.png" alt="企鹅号" title="企鹅号">
          </li>
          <li class="header__partner__item">
            <img width="56" height="56" src="../../assets/logo/circle_80x80/logo_circle_txzb.png" alt="腾讯直播" title="腾讯直播">
          </li>
        </ul>

        <div class="header__register">
          <section class="identity" @click="$router.push('/register')">
            <h2 class="identity__title">
              我是达人
            </h2>
            <p class="identity__content">
              我是媒体平台达人，我可以推广平台<br>
              好物，也可以推广自家货品
            </p>
            <router-link class="identity__link" to="/register">
              立即入驻
            </router-link>
          </section>
         <!--
          <section class="identity" @click="openOmShop">
            <h2 class="identity__title">
              我是供货平台
            </h2>
            <p class="identity__content">
              我是好物供货平台，我可以为平台达人<br>
              提供海量优质货品
            </p>
            <span class="identity__link">
              立即加盟
            </span>
          </section>
          -->
        </div>
      </div>
    </div>
    <!-- ]] 页头 -->

    <div class="container" v-lazy:background-image="bgWhite1" style="background: #FFFFFF 3% top/auto 99.5% no-repeat;">
      <div v-lazy:background-image="bgWhite2" style="background:right bottom no-repeat;">
        <div class="container-inner">
          <div class="scene">
            <div class="scene__img-list">
              <div class="scene__img-list__item" v-lazy:background-image="imgScene1">
                <dl>
                  <dt>直播带货</dt>
                  <dd>在线互动带货，重构电商<br>“人、货、场”销售场景</dd>
                </dl>
              </div>

              <div class="scene__img-list__item" v-lazy:background-image="imgScene2">
                <dl>
                  <dt>图文挂货</dt>
                  <dd>图文挂货，开启阅读购物<br>新体验</dd>
                </dl>
              </div>

              <div class="scene__img-list__item" v-lazy:background-image="imgScene3">
                <dl>
                  <dt>短视频</dt>
                  <dd>短视频挂货粉丝一键get同款<br>让作品更有趣</dd>
                </dl>
              </div>
            </div>

            <div class="scene__intro">
              <h2 class="scene__intro__title">
                多元化带货场景
              </h2>
              <p class="scene__intro__content">
                依托腾讯内容生态, 打造多元化带货场景直播电商、短视频、图文推广带货
              </p>
              <router-link class="ui-link scene__intro__link" to="/register">
                我要入驻&nbsp;&gt;&gt;
              </router-link>
            </div>
          </div>

          <div class="category">
            <div class="category__intro">
              <h2 class="category__intro__title">
                海量优质货源品类齐全
              </h2>
              <p class="category__intro__content">
                精心挑选优质货源，覆盖多元行业&品类
              </p>
              <router-link class="ui-link category__intro__link" to="/register">
                我要入驻&nbsp;&gt;&gt;
              </router-link>
            </div>

            <div class="category__img-list">
              <img v-lazy="imgCategory" width="100%" height="100%">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container container--gray">
      <div class="container-inner">
        <div class="intro intro--recommend">
          <h2 class="intro__title">
            他们都在{{ LOGO_NAME }}
          </h2>
          <p class="intro__content">
            快来一起推荐好物，发现美好生活吧
          </p>
        </div>

        <div class="slide">
          <el-carousel class="slide__main" indicator-position="outside" :autoplay="true" :interval="3000" arrow="never">
            <el-carousel-item v-for="(item, index) in slide" :key="index" class="slide__item">
              <div class="slide__item__wrap">
                <img class="slide__item__img" v-lazy="item.imgUrl" :key="index" width="316" height="320">
                <h2 class="slide__item__title">
                  {{ item.title }}
                </h2>
                <p class="slide__item__content">
                  {{ item.content }}
                </p>
                <div class="slide__item__data" v-html="item.dataHtml" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <div class="container container--white2" v-lazy:background-image="bgWhite3">
      <div class="container-inner">
        <!-- 多元化合作模式 [[ -->
        <div class="intro intro--cooperation">
          <h2 class="intro__title">
            多元化合作模式
          </h2>
          <p class="intro__content">
            提供便捷高效的产品服务，与商家达人深度合作
          </p>
        </div>

        <div class="cooperation">
          <div class="cooperation__section cooperation__section--business">
            <div class="cooperation__section__img">
              <i class="ico ico-business" v-lazy:background-image="imgCooperation1" />
            </div>
            <div class="cooperation__section__info">
              <h2 class="cooperation__section__title">
                商家合作
              </h2>
              <p class="cooperation__section__content">
                为商家提供海量流量媒体平台入口, 连接百万主播和好货销路
              </p>
            </div>
          </div>

          <div class="cooperation__section cooperation__section--talent">
            <div class="cooperation__section__img">
              <i class="ico ico-talent" v-lazy:background-image="imgCooperation2" />
            </div>
            <div class="cooperation__section__info">
              <h2 class="cooperation__section__title">
                达人签约
              </h2>
              <p class="cooperation__section__content">
                为达人提供方便高效的带货工具, 连接海量用户和优质货品
              </p>
            </div>
          </div>
        </div>
        <!-- ]] 多元化合作模式 -->

        <!-- 入驻流程 [[ -->
        <div class="intro intro--settle-in">
          <h2 class="intro__title">
            入驻流程
          </h2>
        </div>

        <div class="settle-in">
          <div class="settle-in__wrap">
            <ol class="settle-in__flow">
              <li>
                <span class="settle-in__number">01</span>
                <strong class="settle-in__title">选择注册方式</strong>
                <em class="settle-in__content">Register</em>
              </li>

              <li>
                <span class="settle-in__number">02</span>
                <strong class="settle-in__title">选择账号类型</strong>
                <em class="settle-in__content">Account number</em>
              </li>

              <li>
                <span class="settle-in__number">03</span>
                <strong class="settle-in__title">填写入驻资料</strong>
                <em class="settle-in__content">Settle in data</em>
              </li>

              <li>
                <span class="settle-in__number">04</span>
                <strong class="settle-in__title">提交平台审核</strong>
                <em class="settle-in__content">Platform audit</em>
              </li>

              <li>
                <span class="settle-in__number">05</span>
                <strong class="settle-in__title">入驻平台成功</strong>
                <em class="settle-in__content">Success</em>
              </li>
            </ol>

            <router-link class="settle-in__btn" to="/register">
              立即入驻
            </router-link>
          </div>
        </div>
        <!-- ]] 入驻流程 -->
      </div>
    </div>
  </div>
</template>

<script>
import imgScene1 from '@/assets/welcome/img_scene_1.png';
import imgScene2 from '@/assets/welcome/img_scene_2.png';
import imgScene3 from '@/assets/welcome/img_scene_3.png';
import imgCategory from '@/assets/welcome/img_category.png';
import slideImgUrl1 from '@/assets/welcome/img_slide_1.png';
import slideImgUrl2 from '@/assets/welcome/img_slide_2.png';
import bgWhite1 from '@/assets/welcome/bg_white_1.jpg';
import bgWhite2 from '@/assets/welcome/bg_white_2.jpg';
import bgWhite3 from '@/assets/welcome/bg_white_3.jpg';
import imgCooperation1 from '@/assets/welcome/img_cooperation_1.png';
import imgCooperation2 from '@/assets/welcome/img_cooperation_2.png';

const isDevEnv = process.env.NODE_ENV === 'development';
const omShopLink = isDevEnv ? 'https://test.seller.txshop.qq.com/index.html#/login' : 'https://seller.txshop.qq.com/index.html#/login';

export default {
  data() {
    return {
      imgScene1,
      imgScene2,
      imgScene3,
      imgCategory,
      bgWhite1,
      bgWhite2,
      bgWhite3,
      imgCooperation1,
      imgCooperation2,
      omShopLink,

      slide: [
        {
          title: '鹅外惊喜',
          content: '全网首档高调宠己直播综艺，与刘谦、杨超越、戚薇、辣目洋子等数十位明星合作，单期亿级流量曝光',
          dataHtml: `
            <ul>
              <li><strong class="label">成交额</strong><em class="data"><span class="number">10</span>亿+</em></li>
              <li><strong class="label">阅读量</strong><em class="data"><span class="number">10</span>亿+</em></li>
              <li><strong class="label">粉丝</strong><em class="data"><span class="number">500</span>万+</em></li>
            </ul>
          `,
          imgUrl: slideImgUrl1,
        },
        {
          title: '鹅外7点见',
          content: '鹅外惊喜衍生带货日播节目，主打美妆、食品，生鲜，家居个护等品类，签约特色主播，培养垂类主播',
          dataHtml: `
            <ul>
              <li><strong class="label">成交额</strong><em class="data"><span class="number">10</span>亿+</em></li>
              <li><strong class="label">阅读量</strong><em class="data"><span class="number">10</span>亿+</em></li>
              <li><strong class="label">粉丝</strong><em class="data"><span class="number">500</span>万+</em></li>
            </ul>
          `,
          imgUrl: slideImgUrl2,
        },
      ],
    };
  },
  methods: {
    openOmShop() {
      window.open(omShopLink);
    },
  },
};
</script>

<style>
/* reset el-popover 组件 */
.popover-login {
  padding: 0 !important;
}
.popover-login .btn-list__item {
  display: block;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  padding-left: 15px;
  color: #333333;
}
.popover-login .btn-list__item:hover {
  background-color: var(--ui-bg-color);
  text-decoration: none;
}
.popover-login .ico {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  vertical-align: -5px;
  margin-right:5px;
}
.popover-login .ico-shop {
  background-image: url("../../assets/welcome/ico_shop.png");
}
.popover-login .ico-diamonds {
  background-image: url("../../assets/welcome/ico_diamonds.png");
}
</style>

<style lang="less" scoped>
@pageMaxWidth: 1400px; //最小页面宽度
@pageContentWidth: 970px; // 内容区宽度

.header {
  background: url("../../assets/welcome/header_bg_1.png") 0 bottom/493px auto no-repeat,
  url("../../assets/welcome/header_bg_3.png") right bottom/493px auto no-repeat,
  url("../../assets/welcome/header_bg_2.png") center center/auto 637px no-repeat,
  linear-gradient(to right, #171616, #131212);
  min-width: 970px;
}

.header__wrap {
  max-width: @pageMaxWidth;
  margin: 0 auto;
  padding: 0 0 120px;
}

.header__logo {
  font-size: 18px;
  font-weight: 400;
}
.header__logo__img {
  display: inline-block;
  width: 112px;
  height: 37px;
  background: url("../../assets/welcome/logo.png");
  background-size: auto 100%;
  vertical-align: -12px;
  margin-right: 3px;
}

.header__nav {
  display: flex;
  justify-content: space-between;
  height: 88px;
  line-height: 88px;
  color: #FFFFFF;
}
.header__links {
  display: flex;
  color: #FFFFFF;
  font-size: 14px;
}
.header__links__item {
  margin-left: 20px;
}
.header__links .link{
  color: #FFFFFF;
}
.header__links .btn-login {
  display: inline-block;
  width: 72px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
  border: 1px solid #696F8A;
  border-radius: 4px;
  cursor: pointer;
}
.header__links .btn-login:hover {
  background-color: var(--ui-main-color);
  border-color: var(--ui-main-color);
  text-decoration: none;
}


.header_intro {
  font-size: 36px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
}
.header__partner {
  display: flex;
  justify-content: center;
  margin: 20px 0 0;
}
.header__partner__item {
  padding: 0 8px;
}

.header__register {
  display: flex;
  justify-content: center;
  padding: 52px 0 0;
}
.header__register .identity {
  width: 332px;
  height: 192px;
  margin: 0 16px;
  border: 1px solid rgba(255,255,255,0.4);
  border-radius: 8px;
  background-color: rgba(255,255,255,0.08);
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}
.header__register .identity:hover {
  background-color: var(--ui-main-color);
  color: var(--ui-base-font-color);
}
.header__register .identity:hover .identity__link{
  border-color: rgba(0, 0, 0, 0.6);
  color: var(--ui-base-font-color);
  text-decoration: none;
}
.header__register .identity__title {
  font-size: 18px;
  font-weight: 400;
  padding: 14px 0 0;
}
.header__register .identity__title::after {
  content: "";
  display: block;
  margin: 14px 40px;
  height: 1px;
  background: linear-gradient(to right, rgba(255,255,255, 0.05), rgba(255,255,255, 0.55), rgba(255,255,255, 0));
}
.header__register .identity:hover .identity__title::after {
  background: linear-gradient(to right, rgba(0,0,0, 0.05), rgba(0,0,0, 0.55), rgba(0,0,0, 0));
}
.header__register .identity__content {
  margin: 14px 0 27px;
}
.header__register .identity__link {
  display: inline-block;
  width: 90px;
  height: 32px;
  line-height: 32px;
  color: #FFFFFF;
  border: 1px solid rgba(255,255,255,0.4);
  border-radius: 4px;
  font-size: 14px;
}

.container--gray {
  background: linear-gradient(to bottom, #F3F4F8, #FFFFFF);
}
.container--white2 {
  background: 0 140px no-repeat;
  background-color: #FFFFFF;
}
.container-inner {
  width: @pageContentWidth;
  margin: 0 auto;
}

// 多元化带货场景
.scene {
  display: flex;
  justify-content: space-between;
  padding-top: 174px;
}
.scene__img-list {
  display: flex;
}
.scene__img-list__item {
  width: 168px;
  height: 222px;
  box-sizing: border-box;
  margin-right: 20px;
  padding: 127px 0 0;
  background-color: #BCBFC1;
  border-radius: 8px;
}
.scene__img-list__item dl {
  height: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  text-align: center;
  padding: 16px 0;
  background: linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0.60) 100%);
}
.scene__img-list__item dt {
  font-size: 16px;
  font-weight: 700;
}
.scene__img-list__item dd {
  margin: 8px 0 0;
  font-size: 12px;
}
.scene__intro {
  width: 352px;
}
.scene__intro__title {
  font-size: 28px;
}
.scene__intro__content {
  margin: 20px 0 0;
  height: 136px;
  font-size: 20px;
  color: #9A9A9A;
}
.scene__intro__link {
  font-size: 20px;
}

// 海量优质货源品类齐全
.category {
  display: flex;
  justify-content: space-between;
  padding: 165px 0 150px;
}
.category__intro {
  width: 355px;
}
.category__intro__title {
  padding-top: 60px;
  font-size: 28px;
}
.category__intro__content {
  margin: 20px 0 0;
  height: 100px;
  font-size: 20px;
  color: #9A9A9A;
}
.category__intro__link {
  font-size: 20px;
}
.category__img-list {
  width: 530px;
  height: 318px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #BCBFC1;
}

// 公共标题和内容
.intro {
  text-align: center;
}
.intro__title {
  font-size: 28px;
}
.intro__content {
  margin: 20px 0 0;
  height: 100px;
  font-size: 20px;
  color: #9A9A9A;
}

.intro--recommend {
  padding-top: 76px
}

// 幻灯片
// reset element 走马灯组件
.slide /deep/ .el-carousel__container {
  height: 330px;
}
.slide /deep/ .el-carousel__button {
  background-color: #DFDFDF;
  height: 4px;
  width: 35px;
  margin: 0 4px;
  opacity: 1;
}
.slide /deep/ .is-active .el-carousel__button {
  background-color: var(--ui-main-color);
}
.slide {
  margin: -10px;
}
.slide__item {
  box-sizing: border-box;
  padding: 56px 10px 10px 10px;
  height: 330px;
}
.slide__item__wrap {
  position: relative;
  height: 264px;
  background-color: #FFFFFF;
  box-shadow: 2px 4px 10px 0 rgba(0,0,0,0.04);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 40px 100px 0 394px;
}
.slide__item__img {
  position: absolute;
  left: 30px;
  bottom: 0;
}
.slide__item__title {
  font-size: 24px;
  margin: 0 0 20px;
}
.slide__item__content {
  font-size: 14px;
}
.slide__item__data /deep/ ul {
  margin: 36px 0 0;
  display: flex;
}
.slide__item__data /deep/ li {
  min-width: 85px;
}
.slide__item__data /deep/ .label {
  display: block;
  color: #CCCCCC;
  font-size: 14px;
  font-weight: 400;
}
.slide__item__data /deep/ .data {
  display: block;
  padding: 5px 0 0;
  font-size: 12px;
  color: var(--ui-main-color);
}
.slide__item__data /deep/ .number {
  font-size: 30px;
  margin-right: 5px;
}
.slide__switch {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.slide__switch__btn {
  background-color: #DFDFDF;
  display: block;
  width: 35px;
  height: 4px;
  overflow: hidden;
  text-indent: -999px;
  margin: 0 8px
}
.slide__switch__btn.active {
  background-color: var(--ui-main-color);
}

// 多元化合作模式
.intro--cooperation {
  padding-top: 170px
}

.ico-business, .ico-talent {
  display: inline-block;
  background: no-repeat 0 0;
  width: 100px;
  height: 100px;
}
.cooperation {
  display: flex;
  justify-content: space-between;
}
.cooperation__section {
  display: flex;
  width: 472px;
  height: 142px;
  background-color: var(--ui-main-color);
  border-radius: 8px;
  color: #FFFFFF;
}
.cooperation__section__img {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 28px 0 46px;
}
.cooperation__section__info {
  width: 258px;
}
.cooperation__section__title {
  padding: 32px 0 6px;
  font-size: 24px;
  font-weight: 400;
}
.cooperation__section__content {
  font-size: 14px;
  line-height: 1.5;
}
.cooperation__section--talent {
  background-color: #262626;
}

// 入驻流程
.intro--settle-in {
  padding: 170px 0 0;
}

.settle-in {
  padding: 70px 0 162px;
}
.settle-in__wrap {
  width: 100%;
  height: 264px;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 5px 22px 0 rgba(0,0,0,0.05);
}
.settle-in__flow {
  display: flex;
  justify-content: center;
  background-color: #FFFFFF;
}
.settle-in__flow li {
  position: relative;
  flex: 1;
  height: 200px;
  box-sizing: border-box;
  padding: 20px 0 0 22px;
}
.settle-in__flow li::after {
  content: "";
  position: absolute;
  right: 0;
  width: 1px;
  height: 136px;
  margin-top: -68px;
  top: 50%;
  background: #EEEFEE;
}
.settle-in__flow li:last-child::after{
  display: none;
}
.settle-in__number {
  display: block;
  font-size: 60px;
  color: var(--ui-main-color);
}
.settle-in__title {
  display: block;
  margin: 10px 0 14px;
  font-size: 24px;
  font-weight: 400;
}
.settle-in__content {
  display: block;
  font-size: 14px;
  color: #CCCCCC;
}
.settle-in__btn {
  display: block;
  height: 64px;
  line-height: 64px;
  font-size: 24px;
  color: var(--ui-base-font-color);
  text-align: center;
  background-color: var(--ui-main-color);
  text-decoration: none;

  &:hover {
    background-color: var(--ui-main-color-hover);
  }
}
</style>
